import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: '[app-tr-supplier]',
  template: `
    <td class="align-middle" >
      <img src="{{supplier?.avatar}}" width="34" class="me-2">
      <a href="" routerLink="/inventory/providers/{{ supplier?.id }}">{{supplier?.name}} {{supplier?.last_anme}}</a>
    </td>
    <td class="align-middle">{{supplier?.email}}</td>
    <td class="align-middle text-cener">
      <div class="badge rounded-pill bg-success text-light" *ngIf="supplier?.active">Activo</div>
      <div class="badge rounded-pill bg-secondary text-light" *ngIf="!supplier?.active">Inactivo</div>
    </td>
    <td class="align-middle">{{supplier?.website}}</td>
  `,
  styles: [
  ]
})
export class TrSupplierComponent {
  @Input() supplier: any;
  @Input() profile: any;
  @Input() permissions: any;

  invURL: string = environment.INV_REST_WSPREFIX;
  local: string = 'http://localhost:8000';

  constructor() { }
}
